import styled from "styled-components"
import IcArrowLeft from "../assets/images/ic_arrow_left.svg"
import { setDeckEffects } from "../utils/setDeckEffects";
import { useSquad } from "../contexts/SquadContext";
import { SelectPopupFixed } from "./SelectPopupFixed";
import { useState } from "react";
import { SelectPopup } from "./SelectPopup";
import { needSelectionType, teamKeys, yearKeys } from "../utils/publicKeys";

//  [대상 선수]
//
//  1. 카드 종류 - 골든 글러브, 시그니쳐 등 - CardType
//  2. 선택 팀 - 두산, 삼성 등 - Team
//  3. 선택 올스타 팀 - 드림, 나눔 등 - AllStarTeam
//  3. 대표 포지션 - 타자, 투수 - MainPosition
//  4. 선택 연도 타자/투수 - 16년도 타자, 20년도 투수 등 - YearMainPosition
//  5. O성 선수 - 3성, 4성, 5성 - NumberOfStar
//  6. 세부 포지션 - 마무리 + 불펜 / 선발 투수 등 - Position
//  7. OVR 이상 타자/투수 - OVR 65 이상 투수 등 - OverMainPosition
//  8. 특정 타선 선수 - 6~9번 타자 선수 - BatterLineup
//  9. 선택 팀 특정 카드 - 두산 시그니쳐 등 - TeamCardType
//  10. 선택 팀 대표 포지션 - 두산 타자 등  - TeamMainPosition


//  [향상 능력치]
//  
//  1. 모든 능력치/특정 능력치 - States 
//  2. 포지션 별 다른 능력치 : 타자 : 인내 +1 / 투수 : 제구 +1 - StatesByMainPosition

const SidebarContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 24rem;
    height: 100%;
    background-color: white;
    z-index: 5;
    display: flex;
    flex-direction: row;

    transition: opacity 0.3s ease-in-out;
    opacity: ${props => (props.$isopen ? '1' : '0')};
    visibility: ${props => (props.$isopen ? 'visible' : 'hidden')};
    pointer-events: ${props => (props.$isopen ? 'auto' : 'none')};
`;

const VerticalSidebarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 0rem;
    overflow: auto;
    &::-webkit-scrollbar {
        display: none; 
        width: 0;
        height: 0;
    }
    
    -ms-overflow-style: none;  
    
    scrollbar-width: none;
    box-sizing: border-box;
`

const SetDeckListContainer = styled.div`
    height: 100%;
    width: 22rem;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    padding-top: 1rem;
`;

const CloseButtonConatiner = styled.div`
    width: 2rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 0.225rem solid #87898A;
`;

const CloseButton = styled.img`
    width: 2rem;
    height: 12rem;
    background-color: #87898A;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0.15rem;
    box-sizing: border-box;
`;

const YearSelectText = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1.2rem;
    font-weight: 700;
    padding-bottom: 1rem;
`

const SelectedYearSelectText = styled(YearSelectText)`
    color: #A939FF;
`

const UnselectedYearSelectText = styled(YearSelectText)`
    color: #B3B3B3;
`

export default function SetDeckSidebar({isSidebarOpen, closeSidebar}) {

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupX, setPopupX] = useState(0);
    const [popupY, setPopupY] = useState(0);
    const [isYearPopupVisible, setIsYearPopupVisible] = useState(false);
    const [yearPopupX, setYearPopupX] = useState(0);
    const [yearPopupY, setYearPopupY] = useState(0);
    const [intitialYear, setInitialYear] = useState(null)
    const [onYearSelect, setOnYearSelect] = useState(() => {})
    const [popupItems, setPopupItems] = useState([]);
    const [popupCols, setPopupCols] = useState(1);
    const [selected, setSelected] = useState(null);
    const [setDeckIndex, setSetDeckIndex] = useState(0);

    const { playerInfos, setPlayers, setProperty } = useSquad();

    const defaultBatterYearText = playerInfos.defaultBatterYear != null ? playerInfos.defaultBatterYear : "없음"
    const defaultPitcherYearText = playerInfos.defaultPitcherYear != null ? playerInfos.defaultPitcherYear : "없음"
    const defaultPlayerYearText = playerInfos.defaultPlayerYear != null ? playerInfos.defaultPlayerYear : "없음"

    const handleSelect = (item) => {

        const index = setDeckIndex
        const setDeckState = playerInfos.setDeckStates[index]

        const newSetDeckState = {...setDeckState}

        newSetDeckState.selected = selected;
        newSetDeckState.selection = item

        setProperty(
            'setDeckStates',
            [
                ...playerInfos.setDeckStates.slice(0, index),
                newSetDeckState,
                ...playerInfos.setDeckStates.slice(index + 1)
            ]
        )

        setIsPopupVisible(false);

    };

    const handleClose = () => {
        setIsPopupVisible(false);
    };

    const selectionItemMap = {
        Team : teamKeys,
        YearPosition : yearKeys,
        TeamCardType : teamKeys,
        TeamPosition : teamKeys
    }

    const popupColsMap = {
        Team : 2,
        YearPosition : 8,
        TeamCardType : 2,
        TeamPosition : 2
    }

    function onChoiceClick(selected, event, setDeckEffect, setDeckState, index) {
        if(setDeckState.isAvailable) {

            if(needSelectionType.includes(setDeckEffect[selected].target.type)) {

                const rect = event.currentTarget.getBoundingClientRect();

                const x = rect.left; 
                const y = rect.top; 
                
                setSetDeckIndex(index);
                setPopupItems(selectionItemMap[setDeckEffect[selected].target.type])
                setPopupCols(popupColsMap[setDeckEffect[selected].target.type])
                setSelected(selected);
                setPopupX(x);
                setPopupY(y);
                setIsPopupVisible(true);

            } else {
                const newSetDeckState = {...setDeckState}

                newSetDeckState.selected = selected;

                setProperty(
                    'setDeckStates',
                    [
                        ...playerInfos.setDeckStates.slice(0, index),
                        newSetDeckState,
                        ...playerInfos.setDeckStates.slice(index + 1)
                    ]
                )
            }
        }
    }

    function onYearClick(event, onSelect, initialYear) {
            const rect = event.currentTarget.getBoundingClientRect();
            setYearPopupX(rect.left);
            setYearPopupY(rect.top);
            setIsYearPopupVisible(true);
            setInitialYear(initialYear)
            setOnYearSelect(() => onSelect)
        }

    const onBatterYearClick = (event) => {
        onYearClick(
            event,
            (item) => {
                setProperty("defaultBatterYear", item)
                setIsYearPopupVisible(false)
            },
            playerInfos.defaultBatterYear
        )
    }

    const onPitcherYearClick = (event) => {
        onYearClick(
            event,
            (item) => {
                setProperty("defaultPitcherYear", item)
                setIsYearPopupVisible(false)
            },
            playerInfos.defaultPitcherYear
        )
    } 

    const onPlayerYearClick = (event) => {
        onYearClick(
            event,
            (item) => {
                setProperty("defaultPlayerYear", item)
                setIsYearPopupVisible(false)
            },
            playerInfos.defaultPlayerYear
        )
    } 

    const PlayerYearSelect = playerInfos.defaultPlayerYear ? SelectedYearSelectText : UnselectedYearSelectText
    const BatterYearSelect = playerInfos.defaultBatterYear ? SelectedYearSelectText : UnselectedYearSelectText
    const PitcherYearSelect = playerInfos.defaultPitcherYear ? SelectedYearSelectText : UnselectedYearSelectText

    return (
        <>
            <PopupContainer x={popupX} y={popupY}>
                <SelectPopup
                    isVisible={isPopupVisible}
                    gridCols={popupCols}
                    items={popupItems}
                    initialValue={playerInfos.setDeckStates[setDeckIndex].selection || null}
                    onClose={handleClose}
                    onSelect={(item) => {handleSelect(item)}}
                />
            </PopupContainer>


            <PopupContainer x={yearPopupX} y={yearPopupY}>
                <SelectPopup
                    isVisible={isYearPopupVisible}
                    gridCols={8}
                    items={[...yearKeys, null]}
                    initialValue={intitialYear}
                    onClose={() => setIsYearPopupVisible(false)}
                    onSelect={onYearSelect}
                />
            </PopupContainer>

            <SidebarContainer $isopen={isSidebarOpen}>

                <VerticalSidebarContainer>

                    {/* <BatterYearSelect onClick={(event) => onBatterYearClick(event)}>타자 년도 : {defaultBatterYearText}</BatterYearSelect>
                    <PitcherYearSelect onClick={(event) => onPitcherYearClick(event)}>투수 년도 : {defaultPitcherYearText}</PitcherYearSelect>
                    <PlayerYearSelect onClick={(event) => onPlayerYearClick(event)}>전체 선수 년도 : {defaultPlayerYearText}</PlayerYearSelect>  */}

                    <SetDeckListContainer>
                        {setDeckEffects.map((effect, index) => {
                            return (
                                <SetDeckItem
                                    setDeckEffect={effect}
                                    setDeckState={playerInfos.setDeckStates[index]}
                                    index={index}
                                    onClick = {(selected, event) => onChoiceClick(selected, event, effect, playerInfos.setDeckStates[index], index)}
                                />
                            )
                        })}
                    </SetDeckListContainer>
                </VerticalSidebarContainer>
                <CloseButtonConatiner>
                    <CloseButton src={IcArrowLeft} onClick={closeSidebar}/>
                </CloseButtonConatiner>
            </SidebarContainer>
        </>
    )
}


const SetDeckPointText = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 1.5rem;
    font-weight: 700;
`

const SetDeckPointTextSelected = styled(SetDeckPointText)`
    color: #A939FF;
`

const SetDeckPointTextAvailable = styled(SetDeckPointText)`
    color: #000000;
`

const SetDeckPointTextUnavailable = styled(SetDeckPointText)`
    color: #B3B3B3;
`

const SetDeckTargetText = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 0.7rem;
    font-weight: 500;
    max-width: 8rem;
    overflow-wrap: break-word;
`

const SetDeckTargetTextSelected = styled(SetDeckTargetText)`
    color: #A939FF;
`

const SetDeckTargetTextUnSelected = styled(SetDeckTargetText)`
    color: #B3B3B3;
`

const SetDeckEffectText = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 0.75rem;
    font-weight: 700;
    max-width: 8rem;
    overflow-wrap: break-word;
`

const SetDeckEffectTextSelected = styled(SetDeckEffectText)`
    color: #A939FF;
`

const SetDeckEffectTextUnSelected = styled(SetDeckEffectText)`
    color: #B3B3B3;
`

const VerticalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;
`

const VerticalContainerAvailable = styled(VerticalContainer)`
    cursor: pointer;
`

const SetDeckHorizontalContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`   

const SideContainer = styled.div`   
    flex: 1;
    display: flex;
    justify-content: center;
`

const PopupContainer = styled.div`
    position: fixed;
    z-index: 20;
    box-sizing: border-box;
    
    top: ${props => props.y}px;
    left: ${props => props.x}px;
`



// {
//     point: 30,
//     left: {
//         target: {
//             type: "CardType",
//             cardTypes: ["임팩트", "시그니쳐", "국가대표", "골든글러브"],
//             label: "임팩트&시그니쳐&국가대표&골든글러브 선수"
//         },
//         effect: {
//             type: "States",
//             states: {s1 = 1, s2 = 0},
//             label: "모든 능력치 +1"
//         }
//     }
// }
//
// type = ["CardType", "Team", "Position", "YearPosition", "OvrPosition" "NumberOfStar", "AllStarTeam", "BatterLineup", "TeamCardType", "TeamPosition"]


function SetDeckItem({setDeckEffect, setDeckState, onClick}) {
    
    const LeftTargetLabel = setDeckState.isAvailable ? setDeckState.selected === 'left' ? SetDeckTargetTextSelected : SetDeckTargetTextUnSelected : SetDeckTargetTextUnSelected
    const RightTargetLabel = setDeckState.isAvailable ? setDeckState.selected === 'right' ? SetDeckTargetTextSelected : SetDeckTargetTextUnSelected : SetDeckTargetTextUnSelected

    const LeftEffectLabel = setDeckState.isAvailable ? setDeckState.selected === 'left' ? SetDeckEffectTextSelected : SetDeckEffectTextUnSelected : SetDeckEffectTextUnSelected
    const RightEffectLabel = setDeckState.isAvailable ? setDeckState.selected === 'right' ? SetDeckEffectTextSelected : SetDeckEffectTextUnSelected : SetDeckEffectTextUnSelected

    const PointText = setDeckState.selected ? SetDeckPointTextSelected : setDeckState.isAvailable ? SetDeckPointTextAvailable : SetDeckPointTextUnavailable

    const ChoiceContainer = setDeckState.isAvailable ? VerticalContainerAvailable : VerticalContainer

    const leftSelectionText = (setDeckState.selected === 'left' && setDeckState.selection && needSelectionType.includes(setDeckEffect[setDeckState.selected].target.type)) ? " : " + setDeckState.selection : ""
    const rightSelectionText = (setDeckState.selected === 'right' && setDeckState.selection && needSelectionType.includes(setDeckEffect[setDeckState.selected].target.type)) ? " : " + setDeckState.selection : ""


    return (
        <SetDeckHorizontalContainer>
            <SideContainer>
                <ChoiceContainer onClick={(e) => {onClick('left', e)}}>
                    <LeftTargetLabel 
                        // 💡 dangerouslySetInnerHTML 적용
                        dangerouslySetInnerHTML={{ __html: setDeckEffect.left.target.label + leftSelectionText }} 
                    />
                    <LeftEffectLabel 
                        // 💡 dangerouslySetInnerHTML 적용
                        dangerouslySetInnerHTML={{ __html: setDeckEffect.left.effect.label }} 
                    />
                </ChoiceContainer>
            </SideContainer>
            
            <PointText>{setDeckEffect.point}</PointText>
            
            <SideContainer>
                <ChoiceContainer onClick={(e) => {onClick('right', e)}}>
                    <RightTargetLabel 
                        // 💡 dangerouslySetInnerHTML 적용
                        dangerouslySetInnerHTML={{ __html: setDeckEffect.right.target.label + rightSelectionText }} 
                    />
                    <RightEffectLabel 
                        // 💡 dangerouslySetInnerHTML 적용
                        dangerouslySetInnerHTML={{ __html: setDeckEffect.right.effect.label }} 
                    />
                </ChoiceContainer>
            </SideContainer>
        </SetDeckHorizontalContainer>
    )
}